<template>
  <div class="card-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <span class="breadcrumb-item" @click="goToMaterial">材价信息</span>
      <img class="separator" src="@/assets/image/you.png" alt="">
      <span class="breadcrumb-item" @click="goToSupplierList">供应商列表</span>
      <img class="separator" src="@/assets/image/you.png" alt="">
      <span>名片展示</span>
    </div>

    <!-- 名片展示区域 -->
    <div class="card-display">
      <div class="business-card">
        <!-- 名片头部 -->
        <div class="card-header">
          <div class="company-logo">
            <img
              :src="supplierInfo.avatar"
              :alt="supplierInfo.companyName"
              class="logo-img"
            >
          </div>
          <div class="company-info">
            <h1 class="company-name">{{ supplierInfo.companyName }}</h1>
            <div class="certification">
              <img
                src="@/assets/image/yrz.png"
                alt="已认证"
                class="cert-icon"
              >
              <span class="cert-text">供应商已认证</span>
            </div>
            <div class="info-row">
              <span class="info-item">入驻时间: {{ supplierInfo.entryDate }}</span>
              <span class="info-item">主营业务: {{ supplierInfo.mainBusiness }}</span>
              <span class="info-item">地区: {{ supplierInfo.location }}</span>
              <span class="info-item contact-item">
                <img
                  src="@/assets/image/phone.png"
                  alt="电话"
                  class="phone-icon"
                >
                电话号码: {{ supplierInfo.phoneNumber }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- 主营业务产品图展示区域 -->
      <div class="product-gallery">
        <h3 class="gallery-title">主营业务产品图</h3>
        <div class="product-grid">
          <div
            v-for="(image, index) in productImages"
            :key="index"
            class="product-item"
          >
            <img
              :src="image"
              :alt="`产品图${index + 1}`"
              class="product-img"
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardList',
  data() {
    return {
      supplierInfo: {
        avatar: require('@/assets/image/1.jpg'),
        companyName: '华东科技',
        entryDate: '2025-03-02',
        location: '河南郑州',
        mainBusiness: '钢材提供',
        phoneNumber: '100 0000 0000'
      },
      productImages: [
        require('@/assets/image/bg1.png'),
        require('@/assets/image/bg2.png'),
        require('@/assets/image/bg3.png'),
        require('@/assets/image/bg4.png'),
        require('@/assets/image/bg1.png'),
        require('@/assets/image/bg2.png'),
        require('@/assets/image/bg3.png'),
        require('@/assets/image/bg4.png')
      ]
    }
  },
  created() {
    // 从路由参数中获取供应商信息
    this.loadSupplierInfo()
  },
  methods: {
    // 加载供应商信息
    loadSupplierInfo() {
      const query = this.$route.query
      if (query.companyName) {
        this.supplierInfo = {
          avatar: require('@/assets/image/1.jpg'),
          companyName: query.companyName || '华东科技',
          entryDate: query.entryDate || '2025-03-02',
          location: query.location || '河南郑州',
          mainBusiness: query.mainBusiness || '钢材提供',
          phoneNumber: query.phoneNumber || '100 0000 0000'
        }
      }
    },
    // 返回材价信息页面
    goToMaterial() {
      this.$router.push('/material')
    },
    // 返回供应商列表页面
    goToSupplierList() {
      this.$router.push('/material/supplierList')
    },
    // 联系供应商
    contactSupplier() {
      this.$message.success(`正在联系 ${this.supplierInfo.companyName}，电话：${this.supplierInfo.phoneNumber}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.card-container {
  width: var(--page-container-ratio, 70%);
  margin: 0 auto;
  padding: 20px;
  min-height: 100vh;
}

/* 面包屑导航 */
.breadcrumb {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  color: #111111;
  font-size: 20px;
  background: #fff;
  height: 80px;
  padding: 0 30px;

  .breadcrumb-item {
    color: #0f6fe2;
    transition: color 0.3s ease;

    &:hover {
      cursor: pointer;
      color: #0c5bc4;
    }
  }

  .separator {
    margin: 0 8px;
    width: 8px;
  }
}

/* 名片展示区域 */
.card-display {
}

/* 名片样式 */
.business-card {
  width: 100%;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  border: 1px solid #e9ecef;
  margin-bottom: 30px;
}

/* 名片头部 */
.card-header {
  display: flex;
  align-items: flex-start;
  padding: 30px;
  background: #fff;

  .company-logo {
    margin-right: 30px;

    .logo-img {
      width: 200px;
      height: 150px;
      border-radius: 8px;
      object-fit: cover;
      border: 1px solid #e9ecef;
    }
  }

  .company-info {
    flex: 1;

    .company-name {
      font-size: 28px;
      font-weight: 600;
      margin: 0 0 15px 0;
      color: #333;
    }

    .certification {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 20px;

      .cert-icon {
        width: 20px;
        height: 20px;
      }

      .cert-text {
        font-size: 14px;
        color: #f39800;
        font-weight: 500;
      }
    }

    .info-row {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .info-item {
        font-size: 16px;
        color: #666;
        line-height: 1.5;

        &.contact-item {
          display: flex;
          align-items: center;
          gap: 8px;
          color: #0f6fe2;

          .phone-icon {
            width: 16px;
            height: 16px;
          }
        }
      }
    }
  }
}

/* 产品图片展示区域 */
.product-gallery {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
  padding: 30px;

  .gallery-title {
    font-size: 20px;
    font-weight: 600;
    color: #333;
    margin: 0 0 20px 0;
  }

  .product-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 15px;

    .product-item {
      aspect-ratio: 1;
      border-radius: 8px;
      overflow: hidden;
      border: 1px solid #e9ecef;

      .product-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.3s ease;

        &:hover {
          transform: scale(1.05);
        }
      }
    }
  }
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .card-container {
    width: 95%;
  }
}

@media (max-width: 768px) {
  .card-container {
    width: 100%;
    padding: 15px;
  }

  .card-display {
    padding: 20px;
  }

  .business-card {
    margin-bottom: 20px;
  }

  .card-header {
    flex-direction: column;
    text-align: center;
    padding: 20px;

    .company-logo {
      margin-right: 0;
      margin-bottom: 20px;

      .logo-img {
        width: 150px;
        height: 120px;
      }
    }

    .company-info {
      .company-name {
        font-size: 24px;
      }

      .info-row {
        .info-item {
          font-size: 14px;
        }
      }
    }
  }

  .product-gallery {
    padding: 20px;

    .gallery-title {
      font-size: 18px;
    }

    .product-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;
    }
  }
}

@media (max-width: 480px) {
  .breadcrumb {
    font-size: 16px;
    height: 60px;
    padding: 0 15px;
  }

  .card-display {
    padding: 15px;
  }

  .card-header {
    padding: 15px;

    .company-logo .logo-img {
      width: 120px;
      height: 100px;
    }

    .company-info {
      .company-name {
        font-size: 20px;
      }

      .info-row {
        .info-item {
          font-size: 13px;
        }
      }
    }
  }

  .product-gallery {
    padding: 15px;

    .gallery-title {
      font-size: 16px;
    }

    .product-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 8px;
    }
  }
}
</style>
